// extracted by mini-css-extract-plugin
export default {"container":"Ev-z","heading":"Fv-z","text":"Gv-z","info":"Hv-z","link":"Iv-z","fullMaxWidth":"Jv-z"};